import React, { memo } from "react";
import { useLocation } from "react-router-dom";
import { strings } from "investira.sdk";
import {
  Stack,
  Typography,
  CircularProgress,
  Button,
  Icon,
} from "investira.react.components";
import { PaginationTemplate } from "../../components/templates";
import { SearchAtivos } from "../../components/organisms";
import services from "../../services";
import AtivosItem from "./AtivosItem";
import AtivosFilter from "./AtivosFilter";
import { ROUTES_MERCADOS } from "../../enums";

const AtivosMercado = memo((props) => {
  const location = useLocation();
  const search = strings.querystringToObject(location.search);
  const pathnameBase = location.pathname.split("/")[2];

  function sort(pSearch) {
    let xValues = "relevancia DESC, mercado ASC";

    if ("pesquisa" in pSearch) {
      xValues = "relevancia DESC, __mr__ DESC, mercado ASC, ativo ASC";
    }

    return xValues;
  }

  console.log(pathnameBase);

  return (
    <PaginationTemplate
      id="ativos"
      title={ROUTES_MERCADOS[pathnameBase].descricao || "Ativos"}
      description={
        ROUTES_MERCADOS[pathnameBase].metadata.description ||
        "Listas de ativos do mercado financeiro! Fundos, títulos públicos, títulos bancários, ações, fundos imobiliários, BDRs, ETFs, tesouro direto e outros mais."
      }
      dataRead={services.ativosbase.list}
      dataReadParams={{
        cancelado: "null",
        sort: sort(search),
        mercado: ROUTES_MERCADOS[pathnameBase]?.id || null,
        // fracionario: 0,
        // prazo: "VST",
      }}
      searchComponent={SearchAtivos}
      filterComponent={AtivosFilter}
      listItem={AtivosItem}
      listItemKey="ifeed_ativo_id"
      // match={`${pathnameBase}/*`}
      match={`${location.pathname}/*`}
      maxWidth="xl"
    />
  );
});

PaginationTemplate.displayName = "PaginationTemplate";

export default AtivosMercado;
